import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { LegalLayout } from "@/pages/legal/LegalLayout";

export default function Terms() {
  useSEO({
    title: "Terms & Conditions | E Telecom",
    description: "Review the Terms & Conditions governing the use of E Telecom's website and communication services.",
    path: "/terms",
  });

  return (
    <LegalLayout title="Terms & Conditions" updated="Last updated: 2026">
      <p>These Terms & Conditions govern your access to and use of the E Telecom website and services. By using our website or services, you agree to these terms.</p>

      <h2>Use of Services</h2>
      <p>You agree to use our services lawfully and in accordance with applicable regulations, platform policies and these terms. You are responsible for the content of communications sent through our services and for obtaining any required consents from recipients.</p>

      <h2>Acceptable Use</h2>
      <ul>
        <li>No unsolicited, spam or unlawful messaging.</li>
        <li>No content that is illegal, harmful, deceptive or infringing.</li>
        <li>Compliance with WhatsApp, SMS (including DLT in India where applicable) and telephony regulations.</li>
      </ul>

      <h2>Service Availability</h2>
      <p>We aim to provide reliable services but do not guarantee uninterrupted or error-free operation. Features and availability may change over time.</p>

      <h2>Intellectual Property</h2>
      <p>All content, branding and materials on this website are the property of E Telecom or its licensors and may not be used without permission.</p>

      <h2>Limitation of Liability</h2>
      <p>To the extent permitted by law, E Telecom shall not be liable for indirect, incidental or consequential damages arising from the use of our website or services.</p>

      <h2>Changes to Terms</h2>
      <p>We may update these terms from time to time. Continued use of our services after changes constitutes acceptance of the revised terms.</p>

      <h2>Contact</h2>
      <p>For questions about these terms, contact us at info@etelecom.in.</p>

      <p className="text-sm text-slate-500">These Terms & Conditions are provided for general informational purposes and do not constitute legal advice.</p>
    </LegalLayout>
  );
}
